/*
 * Auth
 * @module features/App
 */

export const Auth = ({ queryLogout, loggedInUser, children, ...rest }) =>
  queryLogout && loggedInUser ? null : children({ ...rest, loggedInUser });
